import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const banResellerFromAllDealershipsInGroup = async (reseller, groupId, ban = true) => {
  try {
    const identity = typeof reseller === 'string'
      ? { email: reseller }
      : {
          resellerId:
            reseller?.resellerId ||
            (reseller?.id && !reseller.id.includes('@') ? reseller.id : undefined),
          email: reseller?.email,
        };
    const banResellerFromGroupFn = httpsCallable(functions, 'banResellerFromGroupV2');
    const result = await banResellerFromGroupFn({
      ...identity,
      groupId,
      ban,
      requestedApp: 'group_web',
    });
    return {
      success: result.data.success === 'yes',
      bannedScopes: Array.isArray(result.data.bannedScopes)
        ? result.data.bannedScopes
        : undefined,
      banned: result.data.banned || result.data.newBanned || [],
      message: result.data.message
    };
  } catch (error) {
    console.error('Error baneando/desbaneando reseller del grupo:', error);
    notifyPermissionDenied(error);
    return { success: false, bannedScopes: undefined, banned: [], message: error.message };
  }
};
